<!-- <div attr.tid="{{childConfig.config.controlName}}" *ngIf="!childConfig.config.isHidden">
    <div class="tml-tpl-label" *ngIf="!childConfig.config.isLabelHidden">
        <label>{{childConfig.config.controlName}}<span *ngIf="childConfig.config.isRequired"
                style="color:red;">&nbsp;*</span></label>
    </div>
    <div class="tml-tpl-input">
        <kendo-dropdownlist [style.width.px]="childConfig.css.width" [disabled]="true">
            <ng-template kendoMultiSelectHeaderTemplate>
                <div class="popup-template-clear-header">
                    <span class="multiselect-Clear" (click)="clearValue()">Clear</span>
                </div>
            </ng-template>
        </kendo-dropdownlist>
    </div>
</div> -->

<div class="tml-tpl-input tam-contact-control">
    <kendo-dropdownlist [style.width.px]="childConfig.css.width" [disabled]="true">
        <ng-template kendoMultiSelectHeaderTemplate>
            <div class="popup-template-clear-header">
                <span class="multiselect-Clear" (click)="clearValue()">Clear</span>
            </div>
        </ng-template>
    </kendo-dropdownlist>
</div>